<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import formdate from "../../FormComponet/formdatelimit.vue";
import formcheckbox from "../../FormComponet/formcheckbox1_0.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRisklerGirislerCevap from "@/models/StrRisklerGirislerCevap";
export default {
  mixins: [Api, Sabit, StrRisklerGirislerCevap],
  props: ["Id", "AddEdit", "GirisId","Sayac"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    formcombobox,
    formtextarea,
    BirimSecimi,
    formdate,
    formcheckbox
  },
  watch: {
    Sayac() {
    
      this.FormData = this.Id;
        if (this.AddEdit == "Add") {
        this.FormData.GirisId = this.GirisId;
        }
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("StrRisklerGirislerCevap", this.FormData).then((res) => {
            if(res){
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrRisklerGirislerCevap");
            }
          });
        } else {

            this.Update("StrRisklerGirislerCevap", this.FormData).then((res) => {
                if (res) {
            
                  this.$emit("TableUpdate");
                  this.$bvModal.hide("StrRisklerGirislerCevap");
                }
            });

          
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrRisklerGirislerCevap"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrRisklerGirislerCevap.AddEdit.FormTitleEdit')
          : $t('StrRisklerGirislerCevap.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
  {{ FormData }}
      <Form @submit.prevent="onSubmit">


                  <BirimSecimi
                    :title="FormDataType.BirimId.FieldTitle"
                    :title_position="'mb-3'"
                    :YetkiKontrol="1"
                    :selected="FormData.BirimId"
                    :labels_lg="'3'"  
                    :v="$v.FormData.BirimId"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="FormData.BirimId=$event"
                  />

        
    

        <formcombobox
          :FormDataType="FormDataType.Cevaptipi"
          :Value="FormData.Cevaptipi"
          :v="$v.FormData.Cevaptipi"
          @input="FormData.Cevaptipi = $event"
        />

        <formtextarea
          :FormDataType="FormDataType.Cevap"
          :Value="FormData.Cevap"
          :v="$v.FormData.Cevap"
          @input="FormData.Cevap = $event"
        />

        <formdate
          :title_position="'d-block'"
          :labels_lg="6"
          :min="min_tarih | formatDate"
          :max="max_tarih | formatDate"
          :FormDataType="FormDataType.BaslamaTarihi"
          :Value="this.$options.filters.formatDate(FormData.BaslamaTarihi)"
          :v="$v.FormData.BaslamaTarihi"
          @input="FormData.BaslamaTarihi = $event"
          />

          <formdate
            :title_position="'d-block'"
            :labels_lg="6"
            :min="min_tarih | formatDate"
            :max="max_tarih | formatDate"
            :FormDataType="FormDataType.BitisTarihi"
            :Value="this.$options.filters.formatDate(FormData.BitisTarihi)"
            :v="$v.FormData.BitisTarihi"
            @input="FormData.BitisTarihi = $event"
            />

        <formtextarea
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />

        <formcheckbox
          :title_position="'mb-3'"
          :labels_lg="2"
          :FormDataType="FormDataType.Tamamlanma"
          :Value="FormData.Tamamlanma"
          :v="$v.FormData.Tamamlanma"
          @input="FormData.Tamamlanma = $event"
        />

        <button class="btn btn-primary" type="submit">
          {{ $t("StrRisklerGirislerCevap.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
